import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'urlPrefixStripping'
})
export class UrlPrefixStrippingPipe implements PipeTransform {
    transform(url: string) {
        const splitUrl = url?.split('//');
        return splitUrl?.length >= 2 ? this.removeCharFromEnd(splitUrl[1]) : this.removeCharFromEnd(url);
    }

    private removeCharFromEnd(str: string): string {
        if (str?.endsWith("/")) {
            return str.slice(0, -1);
        }
        return str;
    }

}
